<template>
  <div class="activityDetail">
    <heads></heads>
    <div class="container" v-loading="loading">
      <div class="top" >
        <div class="top-box">
          <div class="top-title">{{scheduleName? scheduleName: line.lineTitile}}</div>
          <div class="share" @click="shareDialogVisible = true">
            <i class="fa fa-share-square-o" aria-hidden="true"></i>活动分享
          </div>
        </div>
        <div class="banbottom"> 
          <div class="info-left">
            <div class="banners">
              <div class="swiper-box">
                <swiper
                  :options="swiperOptionTop"
                  class="gallery-top"
                  ref="swiperTop"
                  @slideChangeTransitionEnd="handleTouchEnd"
                >
                  <swiper-slide
                    class="slide"
                    v-for="(item,index) in pageArray.linePictures"
                    :key="index"
                  >
                    <img :src="item.linePicture" @load="handleImgLoad" />
                  </swiper-slide>
                </swiper>
                <div class="gallery-bottom-box">
                  <div class="prev" @click="handlePrevClick">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                  </div>
                  <swiper :options="swiperOptionBottom" class="gallery-bottom" ref="swiperBottom">
                    <swiper-slide
                      class="slide"
                      v-for="(item,index) in pageArray.linePictures"
                      :key="index"
                      :class="[activeIndex === index ? 'active' : '']"
                    >
                      <img
                        :src="item.linePicture"
                        @load="handleImgLoad"
                        :data-index="index"
                        @click="handleBottomClick(index)"
                      />
                    </swiper-slide>
                  </swiper>
                  <div class="next" @click="handleNextClick">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="info-right">
            <!-- <div class="top-title">{{line.lineTitile}}</div> -->
            <div class="label-nav">
              <span>成行人数：{{successNumber}}</span>
              <span>确认人数：{{linePeople.total}}</span>
              <span>余位：<span v-if="!!maxNumber">{{parseInt(maxNumber) - parseInt(linePeople.total)}}</span></span>
              <span>上限人数：{{maxNumber}}</span>
            </div>
            <div class="list-info">
              <!-- <span class="discount" v-if="discountlist && discountlist.length > 0">
                优惠类型：
                <span v-for="(item,index) in discountlist" :key="index">
                  {{item.discountName}}
                  <span v-if="discountlist.length-1>index">，</span>
                </span>
              </span> -->
              <span v-if="line.area">目的地：{{line.area.fullName}}{{line.lineDestination}}</span>
              <span>活动天数：{{line.landDays}}天</span>
              <span v-if="!!startdate">集合时间：{{timeFormat(startdate)}}</span>
              <span>
                集合地点：
                <!-- <span v-for="(item,index) in scheduleGathers" :key="index">{{item.place}},</span> -->
                <span>{{placeList}}</span>
              </span>
              <span class="discount" v-if="discountlist && discountlist.length > 0">
                优惠类型：
                <span v-for="(item,index) in discountlist" :key="index">
                  {{item.discountName}}
                  <span v-if="discountlist.length-1>index">，</span>
                </span>
              </span>
              <span class="discount" v-if="line.distribute">
                 活动分销：
                <span>
                 分销下单成功将获得支付金额的{{line.distributeRatio}}%
                </span>
              </span>
            </div>
            <div class="sign-info">
              <span class="price">{{ parseInt(price) ? `￥${price}` : '价格待定'}}</span>
              <span
                class="button"
                :class="[ parseInt(price)&&line.releaseStatus==1 ? '' : 'disable']"
                @click="signUp()"
              >
                <i class="fa fa-paper-plane" aria-hidden="true"></i>
                {{parseInt(price)&&line.releaseStatus==1 ? '立即报名' : '敬请期待'}}
              </span>
            </div>
            <div class="describe">
              <span class="label">活动特色</span>
              <span class="text">{{line.lineAbstract}}</span>
            </div>
          </div>
        </div>
      </div>

      <swiper :options="swiperOptionleader" class="leader-list" >
        <swiper-slide
          class="slide leader-item"
          v-for="(item,index) in lineLeaders"
          :key="index"
          @click.native="toLeaderDetail(item.memberId)"
        >
          <div class="left">
            <img :src="item.headPicPath" />
          </div>
          <div class="right">
            <div class="name">
              {{item.virtualName}}
              <i
                class="fa"
                :class="[ item.gender.indexOf('female') !== -1 ? 'fa-venus' : 'fa-mars']"
                aria-hidden="true"
              ></i>
            </div>
            <div class="position">
              <i class="fa fa-paper-plane-o" aria-hidden="true"></i> 领队
            </div>
          </div>
        </swiper-slide>
      </swiper>

      <div class="process-box" >
        <swiper :options="processOptionTop" class="process" ref="swiperTops">
          <swiper-slide
            class="slide process-item"
            :class="expirynav==index?'process-active':''"
            v-for="(item,index) in lineSchedules"
            :key="index"
          >
            <span
              class="process-text"
              @click="getExpiry(index,item)"
            >
              <div>{{fomateDateMount(item.startdate)}}-{{fomateDateMount(item.enddate)}}</div>
              <span class="text-col">{{ getStatus(item.signUpStatus) }}</span>
            </span>
            <div class="line" :class="expirynav==index?'line-active':''">
              <span class="one-line"></span>
              <span class="one-line"></span>
              <span class="one-line"></span>
              <span class="one-line"></span>
            </div>
          </swiper-slide>
        </swiper>
      </div>

      <div class="participants" >
        <div class="participants-top">
          <div class="left">
            <i class="fa fa-pencil-square-o color-green" aria-hidden="true"></i>
            已参加的人 （
            <span class="color-green">{{successNumber}}</span>人成行）
          </div>
          <div class="right pull-right">
            总共
            <!-- <span class="color-green">{{mapListLength}}</span> -->
            {{linePeople.total}}人
          </div>
        </div>
        <div class="participants-bottom">
          <div class="participants-item" v-for="(item,index) in mapList" :key="index">
            <el-badge :value="item.SignUpQuanlity" class="item" :hidden="item.SignUpQuanlity <= 1">
              <img :src="item.Member.headPicPath || item.Member.virtualImg" />

              <div class="name">{{ item.Member.virtualName || item.Member.name}}</div>
            </el-badge>
          </div>
          <div class="more"  @click="dialogVisible = true">
            查看
            <br />更多
          </div>
          <el-dialog :visible.sync="dialogVisible" width="60%">
            <div class="dialog-top" slot="title">
              <div class="left">
                <i class="fa fa-pencil-square-o color-green" aria-hidden="true"></i>
                已参加的人 （
                <span class="color-green">{{successNumber}}</span>人成行）
              </div>
              <div class="right">
                总共
                <!-- <span class="color-green">{{mapListLength}}</span>/ -->
                {{joinTotal}}人
              </div>
            </div>
            <div class="dialog-body">
              <div
                class="participants-item"
                v-for="(item,index) in linePeople.maplist"
                :key="index"
              >
                <el-badge
                  :value="item.SignUpQuanlity"
                  class="item"
                  :hidden="item.SignUpQuanlity <= 1"
                >
                  <img :src="item.Member.headPicPath ? item.Member.headPicPath : item.Member.virtualImg" />
                  <div
                    class="name"
                  >{{item.Member.name || item.Member.virtualName}}</div>
                </el-badge>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button size="small" type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>

      <div class="textnav">
        <div
          v-for="(item,index) in navArray"
          :key="index"
          class="textnav-item"
          :class="nav === index?'nac-active':''"
          @click="getNav(index)"
        >   
        <span>{{item}}</span>
        <span v-if="index === 3 && evaluateTotal" class="total">{{evaluateTotal}}</span>
      </div>
      </div>
      <!-- <div class="article" @scroll="handleScroll" ref="content"> -->
      <div class="article" ref="content" v-loading="loading">
        <div class="one notes_text" id="one" ref="one" v-html="line.lineDetail"></div>
        <div class="two notes_text" id="two" ref="two" v-html="line.journeyDetail"></div>
        <div class="three notes_text" id="three" ref="three" v-html="line.costDetail"></div>
        <div class="four " id="four" ref="four">
          <div class="evaluate-content" v-if="line && line.score">
              <total-comment :score="line.score?Number(line.score):0" :evaluteCount="line.evaluateCount?Number(line.evaluateCount):0" 
              :twoStarCount="line.twoStarCount?Number(line.twoStarCount):0"
              :oneStarCount="line.oneStarCount?Number(line.oneStarCount):0"
              :threeStarCount="line.threeStarCount?Number(line.threeStarCount):0"
              :fourStarCount="line.fourStarCount?Number(line.fourStarCount):0"
              :fiveStarCount="line.fiveStarCount?Number(line.fiveStarCount):0"
              ></total-comment>
              <div class="evaluate-list">
                <div class="art-title">最新评价</div>
                <ul>
                <li class="evaluate-item" v-for="(item, index) in evaluateList" :key="index">
                  <div class="evaluate-main">
                  <div class="left">
                    <div class="avatar">
                      <img :src="item.headPicPath" />
                    </div>
                    <span class="name">{{item.username}}</span>
                  </div>
                  <div class="right">
                    <div class="text">{{ item.comment }}</div>
                    <div class="comment-images-out">
                      <image-preview-list v-if="item.image" :height="70" :width="70" :picList="item.image" />

                      <!-- <div class="comment-images"  v-show="item.image" >
                        <img v-for="(image2,index2) in item.image" :key="index2" alt="" :src="image2" @click="previewImage(index2,item.image)"/>
                      </div> -->
                    </div> 
                    <div class="star-wrapper">
                        <el-rate
                          v-model="item.lineScore"
                          disabled
                          :colors="['#FF7E00', '#FF7E00', '#FF7E00']"
                          >
                      </el-rate>
                    </div>
                    <div class="bottom-line">
                      <span class="time">{{fomateDate2(item.departDate)}}出发</span>
                      <span class="leader">{{item.leaderName}}</span>
                    </div>
                  </div>
                </div>
                <div
                    class="seller-reply"
                    v-if="item.evaluateReply"
                  >官方回复:<span class="main"> {{item.evaluateReply}}</span></div>
                </li>
              </ul>
              <div class="viewAll" v-if="this.pageNumber < this.totalPage" @click="toMoreComment">查看更多评论<span class="el-icon-arrow-down"></span></div>
              <div class="viewAll" v-else>没有更多评论了<span class="el-icon-arrow-down"></span></div>
            </div>
              </div>
        </div>
      </div>
    </div>

    <el-dialog title="请用微信扫码分享活动" :visible.sync="shareDialogVisible" width="25%">
      <qrcode-vue
        id="qrcodeBox"
        :size="250"
        :value="`http://www.1778hw.com/m/activity/activityDetail?id=${id}`"
        bgcolor="#fff"
        fgColor="#000"
      ></qrcode-vue>
    </el-dialog>

    <homeFoots></homeFoots>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import totalComment from "@/components/comment/totalComment.vue";
import ImagePreviewList from "@/components/comment/ImagePreviewList.vue";
import {
  debounce,
  fomateDateMount,
  fomateDate,
  timeFormat,
  fomateDate2
} from "@/util/util.js";
import axios from "axios";
// import QRCode from "qrcodejs2";
import qrcodeVue from "qrcode-vue";

export default {
  name: "activityDetail",
  data() {
    return {
      nav: 0,
      navArray: ["线路介绍", "行程介绍", "费用说明","评价"],
      scrollTop: 0,
      divtop: 0,
      scroll: "",
      //弹框
      dialogVisible: false,

      //活动详情参数
      id: "",

      //swiper配置
      swiperOptionTop: {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionBottom: {
        spaceBetween: 10,
        slidesPerView: "4",
        watchSlidesProgress: true,
      },
      swiperOptionleader: {
        spaceBetween: 0,
        // slidesPerView: "auto",
        slidesPerView: "5",
        slideToClickedSlide: true,
        slidesOffsetAfter: 450,
        // watchSlidesVisibility: true,
        grabCursor: true,
        // freeMode:true
        // loop:true
      },
      processOptionTop: {
        spaceBetween: 10,
        // touchRatio: 0.2,
        // centeredSlides: true,
        // slidesPerView: "auto",
        slidesPerView: "8",
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
        //  on:{
        //   click: ()=>{
        //     let swiper = this.$refs.swiperTops.swiper;
        //     let i = swiper.activeIndex;
        //     console.log(i)
        //   }
        // }
      },

      expirynav: 0,
      //活动参数
      pageArray: [],
      line: {},
      lineSchedules: "",
      lineSchedule: "",
      lineLeaders: [],
      linePeople: "",
      scheduleGathers: "",
      scheduleid: "",
      departDate: "",
      expiryDate: "",
      price: 0,

      //offsetTop参数
      oneTop: 0,
      twoTop: 0,
      threeTop: 0,
      fourTop: 0,
      //图片加载监听计数:
      // timer:null
      imageCount: 0,

      //缩略图下标，进度
      activeIndex: 0,
      // progress:0,
      swiperTop: null,
      swiperBottom: null,

      loading: false,

      shareDialogVisible: false,

      signStatus: null,
      discountlist: [], //优惠列表
      // qrCode: null

      startdate:'',
      maxNumber:0,
      joinNumList:0,
      joinTotal:0,
      successNumber:0,
      scheduleName:'',
      shareId:'',
      pageNumber:1,
      pageSize:6,
      evaluateList:[],
      totalPage:0,
      evaluateTotal:0,
      canLoadingMore:false,
    };
  },
  watch: {
  },
  components: {
    heads,
    homeFoots,
    qrcodeVue,
    totalComment,
    ImagePreviewList  
    // QRCode
  },

  computed: {
    navId(index){
      return function(index) {
        switch (index){
          case 0:
            return 'one';
            break;
          case 1:
            return 'two';
            break;
          case 2:
            return 'three';
            break;
        }
      }
    },
    topImageSrc() {
      try {
        return this.pageArray.linePictures[this.activeIndex].linePicture;
      } catch (e) {}
    },
    isLogin() {
      return this.$store.state.memberInfo && this.$store.state.memberInfo.id;
    },
    //异步加载读取不到length时会报错，用try catch是为了屏蔽错误
    mapList() {
      try {
        return this.linePeople.maplist.length > 9
          ? this.linePeople.maplist.slice(0, 9)
          : this.linePeople.maplist;
      } catch (e) {}
    },
    mapListLength() {
      try {
        return this.linePeople.maplist.length > 10
          ? 10
          : this.linePeople.maplist.length;
      } catch (e) {}
    },
    peopleNum() {
      try {
        return this.linePeople.maplist.length;
      } catch (e) {}
    },
    defaultPrice() {
      try {
        for (let item of this.lineSchedules[0].prices) {
          if (item.isDefault) {
            return item.linePrice;
          }
        }
      } catch (e) {}
    },
    placeList() {
      try {
        return this.scheduleGathers.map((item) => item.place).join(",");
      } catch (e) {}
    },
    getStatus(status) {
      return function (status) {
        this.signStatus = status;
        return status;
      };
    },
  },
  methods: {
    debounce, //节流函数
    fomateDateMount,
    fomateDate,
    timeFormat,
    fomateDate2,
    toMoreComment() {
      if (this.loading) return;
      if (!this.canLoadingMore) return;
      this.canLoadingMore = false;
      this.pageNumber += 1;
      if (this.pageNumber > this.totalPage) return;
      this.loading = true;
      try {
        this.getEvaluateList();
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  // 获取数据
  getEvaluateList() {
      this.loading =true;
      axios
        .get(`/mobile/line_evaluate/lineEvaluateList.jhtml`, {
          params: {
            pageNumber: this.pageNumber,
            pageSize: 10,
            lineId:this.id
          },
        })
        .then((res) => {
          this.canLoadingMore = true;
          if (res.data.success) {
            this.loading = false;
            let evaluateList = res.data.returnValue.content;
            console.log("evaluateList",evaluateList)
            if(evaluateList && evaluateList.length>0){
              // evaluateList.forEach(evaluate => {
              //   if(evaluate.image){
              //     evaluate.image = evaluate.image.split(",");
              //   }
              // });
              this.evaluateList = [...this.evaluateList, ...evaluateList];
            }
            console.log("this.evaluateList",this.evaluateList)
            this.totalPage = res.data.returnValue.totalpage;
            this.evaluateTotal = res.data.returnValue.total;
          } else {
            this.$message(res.data.errorReason)
          }
          this.loading = false;
        });
    },
    getExpiry(index,item) {
      this.expirynav = index;
      this.startdate=item.startdate
      // this.departDate = item.departDate;
      // this.expiryDate = item.expiryDate;
      this.price = item.price;
      this.scheduleGathers=item.scheduleGathers
      this.discountlist=item.discountlist
      //更换领队列表
      this.lineLeaders = item.lineLeaders;
      this.scheduleName = item.scheduleName;
      this.scheduleid=item.id
      //更换参加的人的列表
      this.requestLinePeople(this.scheduleid);
    },
    requestLinePeople(id) {
      // console.log("!");
      axios
        .get("/order/findorderbyschedule.jhtml", {
          params: {
            id: id,
          },
        })
        .then((res) => {
          if (res.data.success) {
            const data = res.data.returnValue;
            this.linePeople = res.data.returnValue;
            this.maxNumber=res.data.returnValue.maxNumber
            this.joinTotal=res.data.returnValue.total
            this.successNumber=res.data.returnValue.successNumber
            if (this.linePeople.total === 0) {
              //刷线offsetTop高度
              this.getOffsetTop();
            }

          }
        });
    },
    lineDetail() {
      this.loading = true;
      axios
        .get(`/mobile/line/lineDetail.jhtml`, {
          params: {
            lineId: this.id,
          },
        })
        .then((res) => {
          if (res.data.success) {
            const data = res.data.returnValue;
            this.pageArray = data;
            if (data.line) {
              this.line = data.line;
            }
            this.lineSchedules = data.lineSchedules;

            if (this.lineSchedules.length > 0) {
              this.lineSchedules.forEach(schedule => {
                let scheduleGathers = schedule.scheduleGathers;
              // 集合地点筛除重复项
              let tempScheduleGathers = [];
              if(scheduleGathers && scheduleGathers.length>0){
                scheduleGathers.forEach(scheduleGather => {
                  let isExist = false;
                  tempScheduleGathers.forEach(tempScheduleGather => {
                    if(tempScheduleGather.place == scheduleGather.place){
                      isExist = true;
                    }
                  });
                  if(!isExist){
                    tempScheduleGathers.push(scheduleGather);
                  }
                });
                schedule.scheduleGathers = tempScheduleGathers;
              }
              });
               this.price = this.lineSchedules[0].price;
              this.scheduleid = this.lineSchedules[0].id;
             //请求参加的人的列表
              this.lineLeaders = this.lineSchedules[0].lineLeaders; //设置默认领队列表
              this.discountlist = this.lineSchedules[0].discountlist; //优惠列表
              this.scheduleGathers = this.lineSchedules[0].scheduleGathers; //地点列表
               this.startdate=this.lineSchedules[0].startdate;
                this.requestLinePeople(this.scheduleid); 
            }
              this.loading = false;
          }else{
             this.loading = false;
            this.$message(res.data.errorReason)
          }
        

          // const that = this;
          // this.$nextTick(() => {
          //   that.getOffsetTop();
          // })
        });
    },
    signUp() {
      if (this.isLogin) {
        if (parseInt(this.price) && this.line.releaseStatus == 1) {
          this.$router.push({
            path: `/signUp`,
            query: {
              lineScheduleId: this.scheduleid,
              lineId: this.line.id,
              signStatus: this.signStatus,
               shareId: this.shareId,
            },
          });
        }
      } else {
        this.$message("请先登录");
      }

      // this.$router.push({ path: `/signUp` });
    },
    getNav(index) {
      this.nav = index;

      switch (index) {
        case 0:
          document.documentElement.scrollTop = this.oneTop;
          break;
        case 1:
          document.documentElement.scrollTop = this.twoTop;
          break;
        case 2:
          document.documentElement.scrollTop = this.threeTop;
          break;
        case 3:
          document.documentElement.scrollTop = this.fourTop;
          break;
        default:
          console.log("!");
          document.documentElement.scrollTop = 0;
          break;
      }
    },
    getOffsetTop() {
      //创建节点选择器
      // const query = document.querySelectorAll(el);
      //减去导航栏高度40
      this.oneTop =
        // document.querySelectorAll("#one")[0].offsetTop - 40 + 115 ;
        document.querySelectorAll("#one")[0].offsetTop - 40;
      this.twoTop =
        // document.querySelectorAll("#two")[0].offsetTop - 40 + 115 ;
        document.querySelectorAll("#two")[0].offsetTop - 40;
      this.threeTop =
        // document.querySelectorAll("#three")[0].offsetTop - 40 + 115 ;
        document.querySelectorAll("#three")[0].offsetTop - 40;
      this.fourTop =
        // document.querySelectorAll("#three")[0].offsetTop - 40 + 115 ;
        document.querySelectorAll("#four")[0].offsetTop - 40;
        console.log("oneTop",this.oneTop)
        console.log("twoTop",this.twoTop)
        console.log("threeTop",this.threeTop)
        console.log("fourTop",this.fourTop)
    },
    handleImgLoad() {
      //总计焦点图和缩略图数目,通过计数实现节流
      const length = this.pageArray.linePictures.length * 2;
      if (this.imageCount < length - 1) {
        this.imageCount += 1;
      } else {
        // this.$nextTick(()=>{
        //   that.getOffsetTop()
        // })
        // this.getOffsetTop();

        const that = this;
        // let timer = null;
        // const p = new Promise(() => { //顺延小段时间，等待富文本区域的图片加载.
        //   timer = setTimeout(function(){
        //     that.getOffsetTop();
        //     // clearTimeout(timer);
        //   },500)
        // }).then(()=>{
        //   clearTimeout(timer);
        // })
        const timer = setTimeout(function () {
          that.getOffsetTop();
          clearTimeout(timer);
        }, 500);
      }
    },
    // handleScroll(el) {
    //   let top =
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop ||
    //     window.pageYOffset;
    //   if (0 < top && top <= this.twoTop) {
    //     this.nav = 0;
    //   } else if (top > this.twoTop && top <= this.threeTop) {
    //     this.nav = 1;
    //   } else if (top > this.threeTop) {
    //     this.nav = 2;
    //   }
    // }
    getScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop);
      if (scrollTop >= this.oneTop && scrollTop < this.twoTop) {
        // console.log('1',this.nav);
        if (this.nav !== 0) {
          this.nav = 0;
        }
      } else if (scrollTop >= this.twoTop && scrollTop < this.threeTop) {
        if (this.nav !== 1) {
          this.nav = 1;
        }
      } else if (scrollTop >= this.threeTop  && scrollTop < this.fourTop) {
        if (this.nav !== 2) {
          this.nav = 2;
        }
      }  else if (scrollTop >= this.fourTop ) {
        if (this.nav !== 3) {
          this.nav = 3;
        }
      } else {
        if (this.nav !== 0) {
          this.nav = 0;
        }
      }
    },
    toLeaderDetail(id) {
      this.$router.push({ path: `/leaderDetail`, query: { id: id } });
    },
    handleBottomClick(index) {
      this.swiperBottom.slideTo(index);
      this.swiperTop.slideTo(index);
      this.activeIndex = index;
    },
    handlePrevClick() {
      this.swiperBottom.slidePrev();
      this.swiperTop.slidePrev();
      if (this.activeIndex > 0) {
        this.activeIndex -= 1;
      }
    },
    handleNextClick() {
      this.swiperBottom.slideNext();
      this.swiperTop.slideNext();
      if (this.activeIndex < this.pageArray.linePictures.length - 1) {
        this.activeIndex += 1;
      }
    },
    handleTouchEnd() {
      this.activeIndex = this.swiperTop.realIndex;
      this.swiperBottom.slideTo(this.swiperTop.realIndex);
    },
  },
  mounted() {
    // this.loading = true;

    this.$nextTick(() => {
      this.swiperTop = this.$refs.swiperTop.swiper;
      this.swiperBottom = this.$refs.swiperBottom.swiper;

      // this.qrCode = new QRCode("qrcode", {
      //   width: 220, //二维码的宽度
      //   height: 220, //二维码的高度
      //   text: `http://www.1778hw.com/m/activity/activityDetail?id=${this.id}`
      // });
    });

    this.id = this.$route.query.id;
   if (this.$route.query.shareId) {
      this.shareId = this.$route.query.shareId;
    }
    this.lineDetail();
    this.getEvaluateList();
    window.addEventListener("scroll", this.getScroll);
  },
  created() {
    // this.lineDetail()
  },
  // beforeDestroy() {
  //   window.removeEventListener("scroll", this.handleScroll);
  // }
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
};
</script>

<style scoped>
.activityDetail {
  width: 100%;
  /* height: 100%; */
  /* text-align: left; */
}
.container {
  text-align: left;
}
.top {
  margin: 20px 0;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  /* margin-bottom: 10px; */
}
.banbottom {
  display: flex;
  justify-content: space-between;
}
.top-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top-title {
  font-weight: bold;
  padding: 20px 10px;
  box-sizing: border-box;
  display: inline-block;
}
.share {
  cursor: pointer;
}
.share i {
  margin-right: 4px;
}
.share:hover {
  color: #007741;
}
/*轮播图样式*/
.banners {
}
.info-left {
  width: 48%;
}
.info-right {
  width: 48%;
}
.label-nav {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}
.label-nav > span {
  display: block;
  text-align: center;
  border-left: 1px solid #eeeeee;
  width: 25%;
  font-size: 14px;
}
.label-nav > span:first-child {
  border: none;
}
.list-info {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
}
.list-info .discount {
  display: flex;
  /* align-items: center; */
  flex-wrap: wrap;
  color: #f07621;
}
.list-info > span {
  width: 100%;
  height: 40px;
  font-size: 14px;
  color: #656565;
}
.sign-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.price {
  font-size: 28px;
  color: #de4c4c;
}
.button {
  padding: 8px 16px;
  border-radius: 4px;
  background: #007741;
  color: #ffffff;
  cursor: pointer;
}
.disable {
  background: #656565;
  cursor: not-allowed;
}
.button:hover {
  background: #039252;
}
.disable:hover {
  background: #656565;
}
.describe {
  margin-top: 20px;
}

.label {
  font-size: 12px;
  display: inline-block;
  border-radius: 12px;
  padding: 4px 10px;
  color: #007741;
  border: 1px solid #007741;
}
.text {
  font-size: 14px;
  line-height: 24px;
}
.process-box {
  /* box-sizing: border-box;
  padding: 0 10px; */
}
.process {
  width: 100%;
  /* display: flex; */
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 0 10px;
  /* overflow: hidden; */
}
.process-item {
  cursor: pointer;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  /* width: 10%; */
  height: 70px;
  border: 3px solid #eee;
}
.process-active {
  border: 3px solid #007842;
}

.line {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -9px;
  border-radius: 12px;
}
.one-line {
  display: block;
  width: 16px;
  height: 6px;
  border-radius: 6px;
  background: #eeeeee;
  margin-bottom: 6px;
}
.line-active > .one-line {
  background: #007741;
}
.process-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 14px;
  text-align: center;
}
.text-col {
  display: inline-block;
  margin-top: 6px;
  font-weight: bold;
  color: #007741;
}
/* .one-line {
  position: absolute;
  top: 16%;
  left: -8px;
  width: 16px;
  height: 6px;
  border-radius: 12px;
  background: #007741;
} */
.two-line {
  position: absolute;
  top: 36%;
  left: -8px;
  width: 16px;
  height: 6px;
  border-radius: 12px;
  background: #007741;
}
.three-line {
  position: absolute;
  top: 56%;
  left: -8px;
  width: 16px;
  height: 6px;
  border-radius: 12px;
  background: #007741;
}
.four-line {
  position: absolute;
  top: 76%;
  left: -8px;
  width: 16px;
  height: 6px;
  border-radius: 12px;
  background: #007741;
}
.textnav {
  display: flex;
  width: 100%;
  justify-content: space-around;
  height: 40px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  padding: 0 50px;
  box-sizing: border-box;
  background: #ffffff;
  position: sticky;
  position: -webkit-sticky;
  top: 60px;
  z-index: 1000;
}
.textnav > .textnav-item,
.textnav > a {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}
.textnav > .textnav-item{
  position: relative;
}
.textnav > .textnav-item > .total
{
  position: absolute;
        left: 90%;
        top: 0px;
        height: 16px;
        line-height: 16px;
        font-size: 14px;
        border-radius: 14px;
        padding: 0 10px;
        background-color: #ff5000;
        color: #fff;
}
.nac-active {
  color: #007741;
  font-weight: bold;
  border-bottom: 2px solid #007741;
}
.article {
  /* overflow-y: scroll; */
  /* height: 1300px; */
  padding-bottom: 50px;
}
.article > div {
  padding-bottom: 100px;
  /* min-height: 1000px; */
  /* border: 2px solid black; */
}

/*领队队列样式*/
.leader-list {
  display: flex;
  padding-bottom: 20px;
  /*overflow: hidden;*/
  min-height: 115px;
}
.leader-list .leader-item {
  /*width: 30%;*/
  /*width: 300px;*/
  background-color: #f1f1f1;
  padding: 20px;
  display: flex;
  align-items: center;

  margin-right: 10px;
}
.leader-item .left {
  /* border: 1px solid #ccc; */
  /* padding: 5px; */
  margin-right: 20px;
  min-width: 75px;
  min-height: 75px;
}
.leader-item .left > img {
  width: 75px;
  height: 75px;
}
.leader-item .right {
  /*flex: 1;*/
  padding-left: 20px;
  border-left: 1px solid #ccc;
  white-space: nowrap;
}
.leader-item .right .name {
  font-weight: bold;
}
.leader-item .right .fa-mars {
  color: #007aff;
}
.leader-item .right .fa-venus {
  color: #de4c4c;
}
.leader-item .right .position {
  background-color: #e03a3a;
  color: #fff;
  margin-top: 12px;
  padding: 3px 5px;
  border-radius: 20px;
  text-align: center;
  font-size: 14px;
}
/*成行队列*/
.participants {
  padding-bottom: 30px;
  /*border-bottom: 1px solid #ccc;*/
  /*margin-bottom: 20px;*/
  min-height: 210px;
}
.participants-top {
  padding: 10px;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
}
.participants-top .left {
  display: inline-block;
}
.participants-bottom {
  padding-top: 20px;
  display: flex;
  align-items: center;
  text-align: center;

  position: relative;
  /* min-height: 200px; */
}
.participants-bottom .participants-item {
  padding-right: 22px;
  min-width: 88px;
  min-height: 88px;
}
.participants-bottom img {
  width: 88px;
  height: 88px;
  /* min-height: 88px; */
  border-radius: 50%;
}
.participants-bottom .more {
  cursor: pointer;
  color: #b0b0b0;
  padding-bottom: 20px;

  position: absolute;
  right: 0;
}
.participants-bottom .more:hover {
  font-weight: bold;
  color: #007741;
}
.dialog-top {
  text-align: left;
  display: flex;
}
.dialog-top .right {
  padding-left: 100px;
}
.dialog-body {
  display: flex;
  /*justify-content: space-evenly;*/
  flex-wrap: wrap;
}
.dialog-body .participants-item {
  padding: 22px;
}
/*swiper*/
/*.swiper-box .swiper-button-white{*/
/*  height: 100%;*/
/*  background-color: #777;*/
/*}*/
.gallery-top {
  height: 80% !important;
  width: 100%;
}
.gallery-top .swiper-slide {
  height: 360px;
}
.gallery-top .swiper-slide > img {
  width: 100%;
  height: 100%;
  /* height: 100%; */
  /* height: 350px; */
}
.gallery-bottom-box {
  display: flex;
  margin-top: 12px;
}
.gallery-bottom-box .prev,
.gallery-bottom-box .next {
  flex: 1;
  background: #ccc;
  margin-bottom: 4px;
  font-size: 36px;

  display: flex;
  align-items: center;
  justify-content: center;
  /* text-align: center; */
}
.gallery-bottom-box .prev {
  margin-right: 8px;
}
.gallery-bottom-box .next {
  margin-left: 8px;
}
.gallery-bottom {
  height: 20% !important;
  /* width: 100%; */
  width: 86%;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  /* margin-top: 12px; */
  /* padding: 0 50px; */
}
.gallery-bottom .swiper-slide > img {
  width: 100%;
  box-sizing: border-box;
  height: 85px;
}
/* .gallery-bottom .swiper-slide-active img, */
.gallery-bottom .active img,
.gallery-bottom .swiper-slide > img:hover {
  border: 3px solid rgb(255, 80, 0);
}
/* .swiper-bottom {
  display: flex;
  width: 100%;
  padding-top: 5px;
  height: 20% !important;
  font-size: 0 !important;
  justify-content: space-between;
  flex-wrap: wrap;
}
.swiper-bottom > img{
  width: 23%;
  height: 75px;
  box-sizing: border-box;
  margin-bottom: 8px;
}
.swiper-bottom > .active,
.swiper-bottom > img:hover{
  border: 3px solid rgb(255, 80, 0);
} */
/* .gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
}
.gallery-thumbs .swiper-slide img {
  width: 100%;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  opacity: 0.6;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
} */
.search-wrapper {
  width: 100%;
  /* position: absolute; */
  display: flex;
  justify-content: center;
  bottom: 0px;
  z-index: 9;
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
  padding: 20px 0;

  /* background: rgba(0, 0, 0, 0.38); */
}
.color-green {
  color: #007741;
}
.star-wrapper >>> .el-rate__icon{
        font-size: 28px;
        margin-left: 3px;
        margin-right: 3px;
    }
    .star-wrapper >>> .el-progress-bar__inner{
        font-size: 28px;
        margin-left: 3px;
        margin-right: 3px;
        background-color:'#FF7E00'
    }
</style>
<style scoped>

</style>
<style lang="scss"  scoped>
 .evaluate-list{
              min-height:400px;
              .art-title{
                color:#007741;
                margin-top: 10px;
              }
              .viewAll{
                width:100%;
                text-align:center;
                margin-top:20px;
              }

              ul{
                  .evaluate-item{
                                        
                    padding: 4px 0;
            position: relative;
            display: flex;
            flex-direction: column;
            width: 100%;
                    .evaluate-main{
                    
                    padding: 4px 0;
            position: relative;
            display: flex;
            width: 100%;
            .left{
              flex: 2;
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 150px;
              .avatar{
                width: 140px;
                margin-right: 12px;
                margin:0 5px 5px;
                text-align: center;
                img{
                  width: 100px;
                  height: 100px;
                  border-radius: 50%;
                  vertical-align: top;
                }
              }
              .name {
                width: 120px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                overflow: hidden;
                display: inline-block;
                line-height: 18px;
                height: 18px;
                padding: 0 0px;
                box-sizing: border-box;
                font-size: 16px;
                color: #999;
                text-align: center;
              }
            } 
            .right{
              flex: 9;
              .text{
                line-height: 20px;
                font-size: 16px;
                color: #333;
                padding-left: 10px;
                margin-bottom: 8px;
                text-align: left;
              } 
              .star-wrapper{
                width: 300px;
                height: 24px;
                padding-left: 8px;
                margin-bottom: 6px;
                position: relative;
                padding-left: 8px;
                top: 0px;
                left: -7px;
                display: inline-block;
                font-size: 0;
                vertical-align: top;
              } 
              .comment-images-out{
                 overflow-x: auto;
                 padding-left:10px;
                  .comment-images{
                   display: flex;
                   flex-direction: row;
                   flex-wrap: wrap;
                   img{
                     margin: 10px 10px 10px 0;
                     width: 70px;
                     height: 70px;
                     border-radius: 16px;
                   }
                  }
                }
                .bottom-line{
                color:#999;
                font-size:14px;
                padding-left: 10px;
                .time{
                  margin-right:5px;
                }
                .leader{

                }
              }
              }

                  }
                  .seller-reply{
                    font-size:28px;
                    padding: 15px;
                    margin-top: 10px;
                    background: #F6F6F6;
                    font-size: 16px;
                    color:#ff7e00;
                    .main{
                      color:#333;
                      
                    }
                  }


        }
      }
    }    
</style>



// WEBPACK FOOTER //
// src/components/activityview/activityDetail.vue